import { useConfigStore } from '@/store/config.store';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import type { IFont } from '@/typescript/interfaces/IFont';

export function useFontSelector(selectedFont: Ref<string | undefined>) {
    const { fonts } = storeToRefs(useConfigStore());

    const selectedFontObj = computed(() => fonts.value.find((font) => font.fontFace.family === selectedFont.value) || null);

    function selectFont(font: IFont) {
        if (selectedFont.value !== undefined) {
            selectedFont.value = font.fontFace.family;
        }
    }

    return {
        fonts,
        selectedFontObj,
        selectFont,
    };
}
